export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-primary-500 to-accent-500 rounded-2xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center gap-8 p-8 md:p-12">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-bold text-background-50 font-heading mb-4">移动观影更自由</h2>
              <p className="text-sm md:text-base text-background-50/80 leading-relaxed mb-6 max-w-[500px]">
                下载番茄视频APP，随时随地畅享香蕉视频、红桃视频、蜜桃视频等高清影视内容。支持离线缓存、画质切换、投屏播放，让追剧不再受限制。
              </p>
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4">
                <div className="flex items-center gap-2 px-5 py-2.5 bg-background-50 rounded-full cursor-pointer hover:bg-background-100 transition-colors">
                  <i className="ri-apple-fill text-foreground-950 text-lg"></i>
                  <span className="text-sm font-medium text-foreground-950 whitespace-nowrap">App Store</span>
                </div>
                <div className="flex items-center gap-2 px-5 py-2.5 bg-background-50 rounded-full cursor-pointer hover:bg-background-100 transition-colors">
                  <i className="ri-android-fill text-foreground-950 text-lg"></i>
                  <span className="text-sm font-medium text-foreground-950 whitespace-nowrap">Android 下载</span>
                </div>
              </div>
            </div>
            <div className="flex-shrink-0">
              <div className="w-48 h-48 md:w-56 md:h-56 bg-background-50 rounded-2xl p-3 flex items-center justify-center">
                <img
                  src="https://readdy.ai/api/search-image?query=Clean%20modern%20smartphone%20displaying%20video%20streaming%20app%20interface%20with%20movie%20thumbnails%2C%20minimal%20UI%20design%2C%20warm%20color%20scheme%2C%20mobile%20entertainment%20concept%2C%20flat%20lay%20photography%20style%2C%20clean%20background&width=400&height=400&seq=app-qr-2026&orientation=squarish"
                  alt="番茄视频APP移动端"
                  className="w-full h-full object-contain rounded-xl"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}